import {Component, Input} from '@angular/core';
import {FilterOperations, IFilterGroup} from '../../../../../features/settings-new/models/general/advanced-filter-group.interface';
import {ColDef} from 'ag-grid-community';
import {Store} from '@ngrx/store';
import {
  addGroupToSelectedAdvancedFilterGroup,
  setSelectedAdvancedFilterGroupOperator,
} from '../../../../../features/core/store-shared-filter/shared-filter.actions';

@Component({
  selector: 'app-shared-modal-filters-advanced-root',
  templateUrl: './shared-modal-filters-advanced-root.component.html',
  styleUrls: ['./shared-modal-filters-advanced-root.component.scss'],
  standalone: false,
})
export class SharedModalFiltersAdvancedRootComponent {

  colDefs: ColDef[];
  containerGroup: IFilterGroup;
  topLevelGroups: IFilterGroup[] = [];

  constructor(
    private readonly store: Store,
  ) {
  }

  get canDeleteTopLevelGroup(): boolean {
    return this.topLevelGroups.length > 1;
  }

  @Input() set setColDef(colDefs: ColDef[]) {
    this.colDefs = colDefs;
  }

  @Input() set setContainerGroup(containerGroup: IFilterGroup) {
    if (!containerGroup) {
      this.containerGroup = undefined;
      this.topLevelGroups = [];
      return;
    }
    this.containerGroup = containerGroup;
    this.topLevelGroups = containerGroup.filtersAndGroups.filter(
      (item): item is IFilterGroup => 'filtersAndGroups' in item,
    );
  }

  onAddTopLevelGroupClick(): void {
    if (!this.containerGroup) {
      return;
    }
    this.store.dispatch(addGroupToSelectedAdvancedFilterGroup({
      predecessorID: this.containerGroup.id,
    }));
  }

  onToggleOperator(operator: FilterOperations): void {
    if (!this.containerGroup) {
      return;
    }
    this.store.dispatch(setSelectedAdvancedFilterGroupOperator({
      operator,
      filterGroupId: this.containerGroup.id,
    }));
  }

}
